import React, { FC } from 'react';
import { STOPLIGHT_COLORS } from '../../utils/DataFormatterUtils';

const RemovedStatusDisplay: FC<any> = (): React.ReactElement => {
	return (
		<span
			style={{
				color: STOPLIGHT_COLORS.pureRed,
				background: '#f9e6e6',
				padding: '4px 12px',
				borderRadius: 16,
				whiteSpace: 'nowrap',
			}}
		>
			Removed
		</span>
	);
};

export default RemovedStatusDisplay;
